export default "__VITE_ASSET__vlEkOcDB__"